<div class="toggleOptionRow">
  <div class="toggleOptionDescription">
    <label class="title">{{title}}</label>
    <label class="description">{{description}}</label>
  </div>
  <div class="toggleOptionsSwitch">
    <div class="switchContainer">
      <kh-switch [formControl]="control" [testId]="testId" (isChecked)="isChecked.emit($event)"></kh-switch>
    </div>
  </div>
</div>
